var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { useUniqueId } from '../utils/unique-id.js';
import { useDatePicker } from './useDatePicker.js';
import { startOfDay } from './utils.js';
export const Calendar = (_a) => {
    var { value, onChange } = _a, rest = __rest(_a, ["value", "onChange"]);
    const prefix = useUniqueId('Calendar');
    const handleOnChange = dates => {
        if (!Array.isArray(dates) || dates.length !== 1) {
            onChange === null || onChange === void 0 ? void 0 : onChange(undefined);
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(startOfDay(dates[0]));
    };
    const { startInputField } = useDatePicker(Object.assign({ value, onChange: handleOnChange, mode: 'single', prefix, inline: true, showMonths: 1 }, rest));
    return React.createElement("input", { type: "hidden", className: "hidden", ref: startInputField });
};
//# sourceMappingURL=Calendar.js.map